// src/hooks/useAuth.js
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const navigate = useNavigate();

  const checkAuth = () => {
    const isLoggedIn = localStorage.getItem('admin_logged_in') === 'true';
    
    if (!isLoggedIn) {
      // مستقیماً به صفحه لاگین برو بدون confirm
      navigate('/login', { replace: true });
      return false;
    }
    
    return true;
  };

  return { checkAuth };
};
